// @ts-nocheck: converted from JS

import './CardColumn.scss';
import { useDrop } from 'react-dnd';
import { DraggableTypes } from '@/constants/draggable';
import Checkbox from '@/components/UI/FormElements/Checkbox';
import { FC, ReactNode, ChangeEvent } from 'react';

interface CardColumnProps {
  children: ReactNode;
  className?: string;
  title: ReactNode | string;
  footer?: ReactNode;
  onDrop: (item: any, monitor: any) => void;
  placeholderCard?: ReactNode;
  isSelectable?: boolean;
  hasSpace?: boolean;
  onSelect?: (e: ChangeEvent<HTMLInputElement>) => void;
  actionMenu?: ReactNode;
}

const CardColumn: FC<CardColumnProps> = ({
  children,
  className,
  title,
  footer,
  onDrop,
  placeholderCard,
  isSelectable,
  hasSpace = true,
  onSelect,
  actionMenu,
}) => {
  const [{ isOver, canDrop }, drop] = useDrop(
    {
      accept: DraggableTypes.card,
      canDrop: () => hasSpace,
      drop: (item, monitor) => onDrop(item, monitor),
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    },
    [hasSpace]
  );

  const canDropFirstCard = (!children || children.length === 0) && isOver && canDrop;
  const hasContent = canDropFirstCard || Boolean(children.length);
  const placeholder = placeholderCard ? (
    <div style={{ opacity: 0, height: 90 }}>{placeholderCard}</div>
  ) : (
    <div style={{ width: '100%', height: '200px' }} />
  );

  return (
    <div
      ref={drop}
      className={`overflow-hidden ba bg-light-silver br2 ${className} ${
        isOver && canDrop ? 'b--blue' : 'b--moon-gray'
      }`}
    >
      <div className={'flex flex-row bg-white pa2 justify-between'} style={{ height: '38px' }}>
        <div className={'flex flex-row items-center'}>
          {isSelectable && (
            <Checkbox
              className={'dib mr2'}
              type="checkbox"
              name={`${title}-checkbox`}
              id={`${title}-checkbox`}
              onChange={onSelect}
            />
          )}
          <span className={'f5 lh-title'}>{title}</span>
        </div>
        {actionMenu && <div>{actionMenu}</div>}
      </div>
      <div className={`card-column-content ${hasContent && 'pa2'}`}>
        {canDropFirstCard || !hasContent ? placeholder : children}
      </div>
      <div className={`bg-white pa2 ${!hasSpace ? 'ui__disabled' : ''}`}>{footer}</div>
    </div>
  );
};

export default CardColumn;
